import React from 'react';
import { addMonths } from 'date-fns';
import DatePicker from '@nib-components/date-picker';
import FormControl from '@nib-components/form-control';
import { errorMessage, isValid, isTouched, isFieldOptionalAndEmpty } from '../../util/validationHelpers';
import { AddFunnelPropFromContext } from '../funnel-context';
import { FUNNELS, LABELS as DEFAULT_LABELS } from '../../util/constants';
import { defaultFieldPropTypes } from '../../types';
import { combineHandlerWithFormik } from '../../util/eventHelpers';
const LABELS = {
  ARHI: DEFAULT_LABELS.VISA_END_DATE
};
const VisaEndDate = props => {
  const {
    funnel = FUNNELS.ARHI,
    help = '',
    width = 15,
    name,
    id,
    label,
    disabled,
    input,
    field,
    form,
    months = 24,
    minDate = new Date(),
    coverStartDate = new Date(),
    optional = false,
    onBlur,
    onChange,
    ...otherProps
  } = props;
  // if field is optional we don't want to show the green tick and underline (green box-shadow) when empty.
  let isEmptyAndOptional = optional;
  // name is moved to field.name for formik, input.name for redux-form
  const isFormik = Boolean(field);
  const isReduxForm = Boolean(input);
  const formikOnChange = e => {
    form === null || form === void 0 ? void 0 : form.setFieldValue(id, e);
    form === null || form === void 0 ? void 0 : form.setFieldTouched(id, true);
  };
  const formikOnBlur = () => form === null || form === void 0 ? void 0 : form.setFieldTouched(id, true);
  let inputName = name;
  let handleBlur = onBlur;
  if (isFormik) {
    handleBlur = formikOnBlur;
    inputName = field === null || field === void 0 ? void 0 : field.name;
    isEmptyAndOptional = isFieldOptionalAndEmpty(optional, field);
  } else if (isReduxForm) {
    // Redux-Form _helpfully_ sets the value of the field onBlur (even if a user is just tabbing through the form and not actively selecting an option)
    handleBlur = input === null || input === void 0 ? void 0 : input.onBlur; // eslint-disable-line no-undefined
    inputName = input === null || input === void 0 ? void 0 : input.name;
  }
  const validState = isValid({
    ...otherProps,
    form,
    id
  });
  const validatedState = isTouched({
    ...otherProps,
    form,
    id
  });
  const errorState = errorMessage({
    ...otherProps,
    form,
    id
  });
  const inputFieldValue = isFormik ? field === null || field === void 0 ? void 0 : field.value : input === null || input === void 0 ? void 0 : input.value;
  const handleChange = isFormik ? combineHandlerWithFormik(formikOnChange, onChange) : input === null || input === void 0 ? void 0 : input.onChange;
  return React.createElement(FormControl, {
    name: inputName,
    id: id,
    label: label || LABELS[funnel] || LABELS.ARHI,
    isEmptyAndOptional: isEmptyAndOptional,
    help: help,
    valid: validState,
    validated: validatedState,
    error: errorState,
    width: width,
    disabled: disabled
  }, React.createElement(DatePicker, {
    ...field,
    value: inputFieldValue,
    selected: inputFieldValue,
    onChange: handleChange,
    onBlur: handleBlur,
    minDate: minDate,
    maxDate: addMonths(coverStartDate || new Date(), months),
    shouldCloseOnSelect: true,
    autoComplete: "off",
    isEmptyAndOptional: isEmptyAndOptional
  }));
};
VisaEndDate.defaultProps = {
  ...defaultFieldPropTypes,
  months: 24,
  width: 15,
  minDate: new Date(),
  coverStartDate: new Date(),
  optional: false
};
const VisaEndDateWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(VisaEndDate, {
  ...props
}));
export default VisaEndDateWithFunnel;